import { render, staticRenderFns } from "./Twilio.vue?vue&type=template&id=111475a6&scoped=true&"
import script from "./Twilio.vue?vue&type=script&lang=js&"
export * from "./Twilio.vue?vue&type=script&lang=js&"
import style0 from "./Twilio.vue?vue&type=style&index=0&id=111475a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111475a6",
  null
  
)

export default component.exports